import { css } from 'lit-element';
import BXMultiSelect from 'carbon-web-components/es/components/multi-select/multi-select';
import 'carbon-web-components/es/components/multi-select/multi-select-item';
import './multi-select-item';

class WereHiringSelect extends BXMultiSelect {}
WereHiringSelect.styles = [
  BXMultiSelect.styles,
  css`
    .bx--list-box {
      --cds-body-short-01-font-size: var(--werehiring-input-font-size);
      background-color: var(--werehiring-input-background-color);
      font-size: var(--werehiring-input-font-size);
      height: 100%;
      padding: 12px;
      border-radius: var(--werehiring-input-border-radius);
      border: 1px solid #eceef0;
      max-height: unset;
      font-family: inherit;
    }

    .bx--label {
      display: none;
    }

    .bx--list-box__menu-item__option {
      height: 2em;
    }

    .bx--list-box__menu-item__option {
      height: 3em;
      display: flex;
      justify-content: center;
      padding: 0;
    }

    .bx--form-item.bx--checkbox-wrapper {
      height: 100%;
      display: flex;
      justify-content: center;
    }

    .bx--checkbox-label {
      padding-left: 1.25em;
      display: block;
      width: 100%;
    }

    .bx--checkbox-label::before {
      top: 0.125em;
    }

    bx-multi-select-item {
      height: auto;
    }

    .bx--list-box__label {
      color: var(--werehiring-input-text-color);
      font-size: var(--werehiring-input-font-size);
    }

    #menu-body {
      max-height: 400px;
      background-color: var(--werehiring-input-background-color);
    }
  `,
];

customElements.define('werehiring-select', WereHiringSelect);

export default WereHiringSelect;
